import { useEffect, useState } from 'react';
import { useSettings } from '../context/SettingsContext';

function IOSInstallPrompt() {
  const { getShopName } = useSettings();
  const [showPrompt, setShowPrompt] = useState(false);

  useEffect(() => {
    const isIos = () => {
      const ua = window.navigator.userAgent.toLowerCase();
      return /iphone|ipad|ipod/.test(ua);
    };

    const isInStandaloneMode = () =>
      'standalone' in window.navigator && window.navigator.standalone;

    if (isIos() && !isInStandaloneMode()) {
      setShowPrompt(true);
    }
  }, []);

  if (!showPrompt) return null;

  return (
    <div className="fixed bottom-4 left-4 right-4 card-premium p-4 text-center z-50 animate-slide-up">
      <p className="text-gray-800 dark:text-gray-200 text-sm">
        Për ta instaluar {getShopName()} në iPhone, kliko në <strong>ikonën e ndarjes (Share)</strong> në Safari dhe pastaj zgjidh <strong>"Add to Home Screen"</strong>.
      </p>
    </div>
  );
}

export default IOSInstallPrompt;
